// Centralized API base URL.
// In development, this is empty so requests go through the Vite dev proxy ("/api" -> localhost:8787).
// In production, set VITE_API_BASE_URL to the deployed Worker URL (see .env.production).
export const API_BASE = import.meta.env.VITE_API_BASE_URL || '';

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}
